<div data-testid="zone-tile">
    <div class="zone__top border-zone cursor-pointer"
         (click)="zones.goToMenu(tile)">
        <floating-subtitle class="zone__name zone__name--valve font-21"
                           [text]="subtitle(128)">
        </floating-subtitle>
        <div class="zone__set-temperature bg-gradient bg-gradient--zone font-24 ">
            <p class="zone__set-temp font-bold" data-testid="set-temp">
                {{ tile.params.setTempDHW | format:7 }}
            </p>
        </div>
    </div>

    <div class="zone__status cursor-pointer">
        <div class="gradient-zone zone__status-background"
             data-testid="animation"
             [ngClass]="{ 'zone__status--animated': tile.params.isActive }"
             (click)="zones.goToMenu(tile)"
        ></div>
    </div>

    <div class="zone__content cursor-pointer"
         (click)="zones.goToMenu(tile)">
        <div class="zone__content-icon">
            <icon [iconName]="'DHW'"
                  data-testid="tile-icon-DHW"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--white zone__icon--tile fill-icon-grey'">
            </icon>
            <icon [iconName]="'DHW'"
                  data-testid="tile-icon-DHW-mobile"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--dark  fill-black fill-icon-grey'">
            </icon>
        </div>
        <div class="zone__current-temp" data-testid="tile-value">
            {{ tile.params.currentTempDHW | format:7 }}
        </div>
    </div>

    <div class="zone__footer bg-style">
        <div class="zone__icons"></div>
    </div>

    <div class="zone__relay-status-mobile fill-style">
        <img class="zone__relay-status-img"
             ngSrc="/assets/img/zone_icons/sun_v1-1.svg"
             data-testid="relay-status-mobile-icon"
             [ngClass]="{ 'zone__relay-status-mobile--animated': tile.params.isActive }"
             width="25" height="25" alt=""/>
    </div>
</div>
